import * as React from "react";

import { ShadowRenderingContext } from "./ShadowRenderingContext";

/**
 * This HOC injects the Shadow rendering context into the props of the wrapped component.
 * This is useful for using context props in life-cycle functions other than render like componentDidUpdate,
 * getDerivedStateFromProps etc.
 */
export function withShadowRendering<T>(Component: React.ComponentType<T>) {
  const consumingShadowRendering = (props: T) => {
    return (
      <ShadowRenderingContext.Consumer>
        {(context) => (
          <Component {...props} isShadowRendering={context.isShadowRendering} />
        )}
      </ShadowRenderingContext.Consumer>
    );
  };
  return consumingShadowRendering;
}
